
import './App.css';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import About from './pages/About'
import Contact from './pages/Contact';
import Destination from './pages/Destination'
import Package from './pages/Package';
import Offer from './pages/Offer';
import Yoga from './pages/Yoga';
import Spirituality from './pages/Spirituality';
import Wellness from './pages/Wellness';
import Tourism from './pages/Tourism';

function App() {
    return (
        <div className="App">
            <Router>    
                <Routes>
                    
                    <Route path="/" exact element={<Home />} />
                    <Route path='/about-us' exact element={<About />} />
                    <Route path='/destination' exact element={<Destination />} />
                    <Route path='/contact' exact element={<Contact />} />
                    <Route path='/package' exact element={<Package />} />
                    <Route path='/Offer' exact element={<Offer />} />
                    <Route path='/Spirituality' exact element={<Spirituality />} />
                    <Route path='/yoga' exact element={<Yoga />} />
                    <Route path='/wellness' exact element={<Wellness />} />
                    <Route path='/tourism' exact element={<Tourism />} />
                </Routes>
            </Router>
        </div>
    );
}

export default App;
